/* ============================================================
   The Online Magic Store — storefront behaviour
   Everything here is native Shopify: the Cart AJAX API, the
   Section Rendering API and predictive search. No app required.
   ============================================================ */
(function () {
  'use strict';

  var MS = window.MagicStore || {};
  var routes = MS.routes || {};
  var strings = MS.strings || {};
  var opts = MS.settings || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function announce(msg) {
    var live = document.getElementById('ms-live');
    if (live) live.textContent = msg;
  }

  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('ms-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ms-toast';
      el.className = 'toast';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2600);
    announce(msg);
  }

  /* ------------------------------------------------------------
     Account menu — the desktop form of the app's account sheet
     ------------------------------------------------------------ */
  function initAccount() {
    var btn = $('#openacct');
    var menu = $('#acct');
    if (!btn || !menu) return;

    var veil = $('#acctveil');
    /* Design F (2026-10-06): saves and offers live in this browser, so their
       counts are filled in here; a count only shows when there is one. */
    function count(key) {
      try { var v = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(v) ? v.length : Object.keys(v || {}).length; }
      catch (e) { return 0; }
    }
    function fill() {
      var saves = count('magicstore:saves');
      var offers = count('tms:offers:wallet') + count('tms:offers:codes');
      menu.querySelectorAll('[data-acct-saves-n]').forEach(function (el) {
        el.hidden = !saves; el.textContent = saves + (saves === 1 ? ' item' : ' items');
      });
      menu.querySelectorAll('[data-acct-offers-n]').forEach(function (el) {
        el.hidden = !offers; el.textContent = offers + ' saved';
      });
    }
    function open() {
      fill();
      menu.hidden = false; if (veil) veil.hidden = false;
      document.documentElement.classList.add('acct-open');
      btn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.hidden = true; if (veil) veil.hidden = true;
      document.documentElement.classList.remove('acct-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    /* Phones: the menu is a bottom sheet, so a swipe down closes it. */
    var y0 = null;
    menu.addEventListener('touchstart', function (e) { y0 = menu.scrollTop <= 0 ? e.touches[0].clientY : null; }, { passive: true });
    menu.addEventListener('touchend', function (e) {
      if (y0 !== null && e.changedTouches[0].clientY - y0 > 70) close();
      y0 = null;
    }, { passive: true });
    if (veil) veil.addEventListener('click', close);

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (menu.hidden) { closeSearch(); open(); } else { close(); }
    });
    document.addEventListener('click', function (e) {
      if (!menu.hidden && !menu.contains(e.target) && e.target !== btn) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.msCloseAccount = close;
  }

  /* ------------------------------------------------------------
     Search — takes over the bar, backed by predictive search
     ------------------------------------------------------------ */
  var searchAbort;

  function closeSearch() {
    var panel = $('#searchpanel');
    var veil = $('#searchveil');
    if (panel) panel.hidden = true;
    if (veil) veil.hidden = true;
  }

  function initSearch() {
    var panel = $('#searchpanel');
    var veil = $('#searchveil');
    var input = $('#searchinput');
    var results = $('#searchresults');
    var defaults = $('#searchdefaults');
    if (!panel || !input) return;

    function open() {
      if (window.msCloseAccount) window.msCloseAccount();
      panel.hidden = false;
      if (veil) veil.hidden = false;
      input.focus();
      input.select();
    }

    $$('[data-open-search]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });

    var cancel = $('#closesearch');
    if (cancel) cancel.addEventListener('click', closeSearch);
    if (veil) veil.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });

    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();

      if (q.length < 2) {
        if (results) results.innerHTML = '';
        if (defaults) defaults.hidden = false;
        return;
      }

      timer = setTimeout(function () { runSearch(q, results, defaults); }, 220);
    });
  }

  function runSearch(q, results, defaults) {
    if (!results) return;
    if (searchAbort) searchAbort.abort();
    searchAbort = new AbortController();

    var url = routes.predictive + '?q=' + encodeURIComponent(q) +
      /* limit_scope=each: six of every type, not six shared between them.
         A shared limit let collections and posts crowd the products out
         (QA 2026-09-29 #6: "card" showed two display cases). */
      '&resources[type]=product,collection,page,article' +
      '&resources[limit]=6' +
      '&resources[limit_scope]=each' +
      '&section_id=predictive-search';

    fetch(url, { signal: searchAbort.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('Search failed: ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var payload = doc.querySelector('#predictive-results');
        results.innerHTML = payload ? payload.innerHTML : '';
        if (defaults) defaults.hidden = true;
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        /* Search is an enhancement — if it fails, the form still submits. */
        results.innerHTML = '';
        if (defaults) defaults.hidden = false;
      });
  }

  /* ------------------------------------------------------------
     Cart — add, change, remove, re-render
     ------------------------------------------------------------ */
  function refreshSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var incoming = new DOMParser().parseFromString(sections[id], 'text/html');
      var source = incoming.querySelector('[data-section-id="' + id + '"]');
      var target = document.querySelector('[data-section-id="' + id + '"]');
      if (source && target) {
        var hadFocus = target.contains(document.activeElement);
        target.innerHTML = source.innerHTML;
        /* Redrawing an open drawer drops focus on the body; keep it inside. */
        if (hadFocus && !target.hidden) {
          var keep = target.querySelector('.dh [data-close-drawer]') || target.querySelector('button, a[href]');
          if (keep) keep.focus({ preventScroll: true });
        }
      }
    });
  }

  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  function getCart() {
    return fetch(routes.cart, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addToCart(id, quantity, button) {
    var item = { id: Number(id), quantity: quantity || 1 };
    /* A pre-order carries its promise into the bag and on to the order:
       "Pre-order: Ships <date>" as a line property (QA 2026-09-29 #12a).
       The button holds the text; initVariants keeps it in step with the
       chosen variant. */
    var pre = button && button.getAttribute && button.getAttribute('data-preorder');
    if (pre) {
      item.properties = {};
      item.properties[strings.preorderKey || 'Pre-order'] = pre;
    }
    return addItems([item], button);
  }

  /* Several lines in one request — the deck builders add a whole box at once,
     and one request means one drawer refresh and no half-added bundle. */
  function addItems(items, button) {
    /* innerHTML, not textContent: an icon-only button (the gift guide's bag
       button) would come back empty. */
    var original = button ? button.innerHTML : null;
    if (button) { button.disabled = true; button.textContent = '…'; }

    return fetch(routes.cart_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: 'cart-drawer'
      })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) {
          /* Shopify returns a human-readable reason — show that, not a status code. */
          toast(res.body && res.body.description ? res.body.description : 'That could not be added.');
          return null;
        }
        refreshSections(res.body.sections);
        return getCart().then(function (cart) {
          setCartCount(cart.item_count);
          if (opts.cartDrawer) openDrawer(); else toast(strings.added || 'Added to your bag');
          announce(strings.added || 'Added to your bag');
          return cart;
        });
      })
      .catch(function () { toast('Something went wrong. Please try again.'); })
      .finally(function () {
        if (button) { button.disabled = false; if (original !== null) button.innerHTML = original; }
      });
  }

  window.TOMSCart = { addItems: addItems, money: function (c) { return formatMoney(c); } };

  function changeLine(key, quantity) {
    return fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        var cart = res.body || {};
        /* Asking for more than there is comes back 422 with a reason ("You
           can only add 3 ..."). Say it, then put the bag back the way the
           server has it: the count, the drawer and the quantity box
           (QA 2026-09-29 #11). Before, the error body went on as if it were
           a cart and the bag count vanished. */
        if (!res.ok || cart.status || typeof cart.item_count !== 'number') {
          toast(cart.description || cart.message || strings.cartUpdateFailed || 'Could not update your bag.');
          return resyncCart();
        }
        refreshSections(cart.sections);
        setCartCount(cart.item_count);
        /* The full Bag page is server-rendered, so reload it to stay truthful. */
        if (document.body.classList.contains('template-cart')) window.location.reload();
        else paintCodeNotes(cart);
        return cart;
      })
      .catch(function () { toast(strings.cartUpdateFailed || 'Could not update your bag.'); return resyncCart(); });
  }

  /* Re-read the bag and redraw everything that shows it. */
  function resyncCart() {
    return fetch('/?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) { if (sections) refreshSections(sections); })
      .catch(function () {})
      .then(getCart)
      .then(function (cart) {
        setCartCount(cart.item_count);
        /* The Bag page is not re-rendered, so its boxes are reset by hand. */
        $$('[data-line-key]').forEach(function (input) {
          var line = (cart.items || []).filter(function (i) { return i.key === input.dataset.lineKey; })[0];
          if (line) input.value = line.quantity;
        });
        paintCodeNotes(cart);
        return cart;
      })
      .catch(function () {});
  }
  document.addEventListener('cart:refresh', function () {
    if (document.body.classList.contains('template-cart')) window.location.reload();
    else resyncCart();
  });

  /* ------------------------------------------------------------
     Discount codes on the bag (QA 2026-09-29 #10). Liquid prints the
     codes that took effect, with their amount and a remove control
     (snippets/cart-discounts.liquid). Liquid cannot see a code that was
     entered but does not apply, so those are read from /cart.js and
     listed with the reason and the same remove control.
     Shopify replaces the whole list on /cart/update.js, so removing one
     code sends the ones that should remain.
     ------------------------------------------------------------ */
  function setCartCodes(codes) {
    return fetch(routes.cart_update, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(','), sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return cart; }
        if (cart && cart.sections) refreshSections(cart.sections);
        if (cart && typeof cart.item_count === 'number') setCartCount(cart.item_count);
        paintCodeNotes(cart);
        return cart;
      })
      .catch(function () { toast(strings.cartUpdateFailed || 'Could not update your bag.'); });
  }

  function removeCartCode(code) {
    var c = String(code || '').toUpperCase();
    return getCart().then(function (cart) {
      var keep = (cart.discount_codes || [])
        .map(function (d) { return d.code; })
        .filter(function (x) { return String(x).toUpperCase() !== c; });
      return setCartCodes(keep);
    });
  }

  function paintCodeNotes(cart) {
    var hosts = $$('[data-cart-code-notes]');
    if (!hosts.length) return;
    var draw = function (cart) {
      var bad = ((cart && cart.discount_codes) || []).filter(function (d) { return d.applicable === false; });
      hosts.forEach(function (host) {
        host.innerHTML = bad.map(function (d) {
          return '<p class="cdisc__bad">' +
            esc((strings.codeNotApplicable || '[code] can’t be used on this bag. Check the minimum spend or the products it covers.').replace('[code]', d.code)) +
            ' <button type="button" class="cdisc__x" data-remove-code="' + esc(d.code) + '" aria-label="' +
            esc((strings.removeCode || 'Remove [code]').replace('[code]', d.code)) + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg>' +
            '</button></p>';
        }).join('');
        host.hidden = !bad.length;
      });
    };
    if (cart && cart.discount_codes) draw(cart);
    else getCart().then(draw).catch(function () {});
  }

  function initCart() {
    /* Add to Bag on the product page, and Buy straight from a shelf. */
    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-add-to-cart]');
      if (add) {
        e.preventDefault();
        var form = add.closest('form');
        var id = add.dataset.variantId ||
          (form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value);
        var qtyField = form && form.querySelector('[name="quantity"]');
        if (id) addToCart(id, qtyField ? Number(qtyField.value) : 1, add);
        return;
      }

      var minus = e.target.closest('[data-qty-down]');
      var plus = e.target.closest('[data-qty-up]');
      if (minus || plus) {
        var wrap = (minus || plus).closest('.qty');
        var input = wrap && wrap.querySelector('input');
        if (!input) return;
        var next = Number(input.value) + (plus ? 1 : -1);
        if (next < 0) next = 0;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      var rm = e.target.closest('[data-remove-line]');
      if (rm) {
        e.preventDefault();
        changeLine(rm.dataset.removeLine, 0);
        return;
      }

      var code = e.target.closest('[data-remove-code]');
      if (code) {
        e.preventDefault();
        code.disabled = true;
        removeCartCode(code.getAttribute('data-remove-code'));
        return;
      }

      /* "Be the first to write one" opens Judge.me's own form: click the
         widget's write link (it binds the form) and bring it into view. */
      var wr = e.target.closest('[data-write-review]');
      if (wr) {
        var widget = document.querySelector('.jdgm-review-widget, .jdgm-widget .jdgm-rev-widg, .jdgm-rev-widg');
        var writeLink = document.querySelector('.jdgm-write-rev-link');
        if (!widget && !writeLink) return;
        e.preventDefault();
        var form = document.querySelector('.jdgm-form-wrapper');
        var formOpen = form && form.offsetHeight > 0;
        if (writeLink && !formOpen) writeLink.click();
        (widget || writeLink).scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-line-key]');
      if (!input) return;
      changeLine(input.dataset.lineKey, Number(input.value));
    });
  }

  /* ------------------------------------------------------------
     Cart drawer
     ------------------------------------------------------------ */
  /* Focus stays inside the open drawer and goes back to whatever opened
     it when it closes (QA 2026-09-29 #45). */
  var drawerOpener = null;

  function drawerFocusables(d) {
    return $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', d.querySelector('.panel') || d)
      .filter(function (el) { return el.getClientRects().length > 0; });
  }

  function openDrawer() {
    var d = $('#cart-drawer');
    if (!d) return;
    if (d.hidden) drawerOpener = document.activeElement;
    d.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var close = d.querySelector('.dh [data-close-drawer]') || d.querySelector('button[data-close-drawer]');
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = $('#cart-drawer');
    /* Escape closes it from anywhere, so only act when it is open: resetting
       the scroll lock under another dialog would unlock that one. */
    if (!d || d.hidden) return;
    d.hidden = true;
    document.documentElement.style.overflow = '';
    var back = drawerOpener;
    drawerOpener = null;
    if (back && back.focus && document.contains(back) && back !== document.body) {
      try { back.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function initDrawer() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-close-drawer]')) closeDrawer();
      if (e.target.closest('[data-open-drawer]')) {
        var d = $('#cart-drawer');
        /* With no drawer on the page (or drawer disabled) the link goes to /cart. */
        if (d && opts.cartDrawer) { e.preventDefault(); openDrawer(); }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var d = $('#cart-drawer');
      if (!d || d.hidden) return;
      var f = drawerFocusables(d);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      var inside = d.contains(document.activeElement);
      if (e.shiftKey && (document.activeElement === first || !inside)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !inside)) { e.preventDefault(); first.focus(); }
    });
  }

  /* ------------------------------------------------------------
     Variant picker
     ------------------------------------------------------------ */
  function initVariants() {
    $$('[data-variant-picker]').forEach(function (picker) {
      var dataEl = document.getElementById(picker.dataset.variantPicker);
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var form = picker.closest('form');
      /* Scope to the section, not the form: the price and stock have moved in
         and out of the form across layouts, and twice that silently left a
         stale price next to a changed variant. The section always contains
         both, whatever the layout does next. */
      var scope = picker.closest('[data-section-id]') || form || document;
      var idField = form && form.querySelector('[name="id"]');
      /* Plural: the price and the buy button each appear twice on a phone —
         once in the rail, once in the sticky bar — and updating only the
         first leaves the other quoting the variant you just changed away
         from.

         The filter is not optional. A save button carries data-price too, as
         the value it stores in the saved list rather than something to
         display, and rewriting its innerHTML replaces the bookmark with a
         price. Same attribute, two jobs — the collision only stayed hidden
         while this looked at the first match. */
      var priceEls = $$('[data-price]', scope).filter(function (el) {
        return !el.hasAttribute('data-save');
      });
      var stockEl = $('[data-stock]', scope);
      var buttons = $$('[data-add-to-cart], [data-jump-options], [data-choose-first], [data-buy-slot]', scope);
      var notifyOn = !!(MS.notify && MS.notify.enabled);
      var pHandle = picker.getAttribute('data-handle') || '';
      var pTitle = picker.getAttribute('data-title') || '';

      var groups = $$('fieldset', picker).length || 1;
      var bar = $('[data-buybar]');

      function selected() {
        return $$('input:checked', picker).map(function (i) { return i.value; });
      }

      function update(e) {
        var chosen = selected();

        /* Two different nothings. An incomplete selection is the customer
           not having decided yet — the page should keep quoting a from-price
           and keep pointing at the options. A complete selection with no
           matching variant is a combination that does not exist, which is
           the only one that deserves "Unavailable". Collapsing them would
           tell someone who has touched nothing that the product is sold
           out. */
        if (chosen.length < groups) return;

        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });

        if (!match) {
          buttons.forEach(function (b) {
            b.removeAttribute('data-notify');
            b.disabled = true; b.textContent = strings.unavailable || 'Unavailable';
          });
          if (stockEl) stockEl.innerHTML = '';
          return;
        }

        /* A choice now exists: the rail and the card become buy controls,
           and accelerated checkout is safe to reveal. */
        if (bar) bar.classList.remove('is-choose');
        if (scope.classList) scope.classList.remove('is-choose');
        buttons.forEach(function (b) {
          if (b.hasAttribute('data-jump-options') || b.hasAttribute('data-choose-first')) {
            b.removeAttribute('data-jump-options');
            b.removeAttribute('data-choose-first');
            b.setAttribute('data-add-to-cart', '');
          }
        });

        if (idField) idField.value = match.id;
        /* A pre-order can be true of one variant and not another, so the note
           follows the choice rather than the product. */
        $$('[data-preorder-note]', scope).forEach(function (n) {
          n.hidden = !(match.preorder && match.available);
        });

        /* Delivery lines follow the variant: a product can hold a physical
           option and a download, and a parcel promise on the download is a
           promise the shop cannot keep. */
        if (typeof match.requires_shipping === 'boolean') {
          $$('[data-ship-physical]', scope).forEach(function (el) { el.hidden = !match.requires_shipping; });
          $$('[data-ship-digital]', scope).forEach(function (el) { el.hidden = match.requires_shipping; });
        }
        priceEls.forEach(function (el) { el.innerHTML = match.price_html; });

        /* A colour with its own photo shows that photo (initGallery listens).
           Only on a real choice: the first run on load must leave the trailer
           in the frame. */
        if (e && match.featured_media_id) {
          try {
            document.dispatchEvent(new CustomEvent('gallery:media', { detail: { id: match.featured_media_id } }));
          } catch (e) {}
        }

        /* A save records the variant the shopper is actually looking at —
           otherwise the saved list links back to whichever one happened to
           load first, at that one's price. */
        $$('[data-save]', scope).forEach(function (b) {
          b.dataset.variantId = match.id;
          if (typeof match.price === 'number') b.dataset.priceCents = match.price;
        });
        if (stockEl) { stockEl.innerHTML = match.stock_html; }

        buttons.forEach(function (b) {
          b.dataset.variantId = match.id;
          /* A sold-out choice gets the back-in-stock button, not a dead one
             (QA 2026-09-29 #33); choosing an available one turns it back. */
          if (!match.available && notifyOn && pHandle) {
            b.removeAttribute('data-add-to-cart');
            b.setAttribute('data-buy-slot', '');
            b.setAttribute('data-notify', pHandle);
            b.setAttribute('data-notify-title', pTitle);
            b.setAttribute('data-notify-variant', match.id);
            b.type = 'button';
            b.disabled = false;
            b.textContent = b.hasAttribute('data-short')
              ? (strings.notifyShort || 'Notify me')
              : (strings.notifyMe || 'Email me when back in stock');
            return;
          }
          if (b.hasAttribute('data-notify')) {
            b.removeAttribute('data-notify');
            b.removeAttribute('data-notify-title');
            b.removeAttribute('data-notify-variant');
          }
          if (match.available) b.setAttribute('data-add-to-cart', '');
          if (match.available && match.preorder && match.preorder_text) b.setAttribute('data-preorder', match.preorder_text);
          else b.removeAttribute('data-preorder');
          b.disabled = !match.available;
          b.textContent = match.available
            ? (match.preorder ? (strings.preorder || 'Pre-order') : (strings.addToBag || 'Add to bag'))
            : (strings.soldOut || 'Sold out');
        });

        /* Keep the URL shareable without adding a history entry per click. */
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', update);
      update();
    });
  }

  /* ------------------------------------------------------------
     Saves — the browser is the cache, the store's own backend is
     the record.

     A press paints and stores locally at once and posts afterwards:
     a bookmark that waits for the network reads as a broken button.
     The signed-in read is where it pays off — the backend folds this
     browser's list into the customer's account, so it is there on
     the next device. Signed out, a shopper sees this browser's list,
     which is empty after a merge until they save something again.

     With no endpoint set, or the proxy unreachable, every one of
     these calls is skipped or dropped and saves stay in this browser
     alone — which is exactly what they were before.

     Saving needs an account (Rich's call, 2026-09-25). A signed-out
     press remembers the product for this tab, goes to sign-in with a
     return_url, and the save is made when the shopper lands back here.
     Signed out, no list is shown and this browser's cached copy is
     dropped — on a shared computer it is somebody else's list.
     ------------------------------------------------------------ */
  var SAVES_KEY = 'magicstore:saves';
  /* The same browser id the offers wallet uses. One visitor, one id:
     the backend keys a guest's saves and their claimed offers alike. */
  var BROWSER_KEY = 'tms:browser';
  var savesEndpoint = (opts.savesEndpoint || '').replace(/\/$/, '');
  var PENDING_KEY = 'tms:pending-save';

  function readSaves() {
    try { return JSON.parse(localStorage.getItem(SAVES_KEY)) || []; }
    catch (err) { return []; }
  }

  function writeSaves(list) {
    try { localStorage.setItem(SAVES_KEY, JSON.stringify(list)); }
    catch (err) { /* private mode — saving is simply unavailable */ }
  }

  function browserId() {
    var id = '';
    try { id = localStorage.getItem(BROWSER_KEY) || ''; } catch (e) {}
    if (!id) {
      id = 'b' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      try { localStorage.setItem(BROWSER_KEY, id); } catch (e) {}
    }
    return id;
  }

  function isSaved(handle) {
    return readSaves().some(function (s) { return s.handle === handle; });
  }

  function toggleSave(data) {
    var list = readSaves();
    var at = list.findIndex(function (s) { return s.handle === data.handle; });
    if (at > -1) { list.splice(at, 1); } else { list.unshift(data); }
    writeSaves(list);
    return at === -1;
  }

  /* --- talking to the backend --------------------------------- */

  function savesUrl() {
    return savesEndpoint + '?browser=' + encodeURIComponent(browserId());
  }

  /* The backend stores ids; the browser renders copy. Both shapes carry
     both, and this is the only place that knows which name is which. */
  function toServer(s) {
    return {
      product_id: s.productId || '',
      variant_id: s.variantId || '',
      handle: s.handle || '',
      title: s.title || '',
      url: s.url || '',
      image: s.image || '',
      price: s.price || '',
      price_cents: typeof s.priceCents === 'number' ? s.priceCents : null
    };
  }

  function fromServer(item) {
    return {
      handle: item.handle,
      productId: item.product_id,
      variantId: item.variant_id,
      title: item.title,
      url: item.url,
      image: item.image,
      price: item.price,
      priceCents: item.price_cents
    };
  }

  /* The list the backend holds wins: two tabs, two devices and a phone that
     was offline all disagree, and only one of them is the record. */
  function adopt(items) {
    if (!Array.isArray(items)) return;
    writeSaves(items.map(fromServer));
    paintSaves();
    renderSaved();
  }

  function pushSave(data, saved) {
    if (!savesEndpoint || !data.productId) return;
    fetch(savesUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ item: toServer(data), saved: saved,
                             browser: browserId() })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (out) { if (out && out.items) adopt(out.items); })
      .catch(function () { /* the press stands locally; the next read reconciles */ });
  }

  function pullSaves(then) {
    then = then || function () {};
    if (!savesEndpoint) { then(); return; }
    fetch(savesUrl(), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (out) {
        if (!out || !Array.isArray(out.items)) return;
        var mine = readSaves();
        /* Nothing up there and something down here is not an empty list — it
           is a list the backend has never been told about. That covers the
           first load after this shipped, and any save made while the proxy
           was down. Send it up rather than wiping it. */
        if (!out.items.length && mine.length) {
          mine.forEach(function (s) { pushSave(s, true); });
          return;
        }
        adopt(out.items);
      })
      .catch(function () { /* offline or not deployed: the cache stands */ })
      .then(then);
  }

  /* --- signed out ----------------------------------------------- */

  function signIn(data) {
    try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(data)); } catch (e) {}
    /* loginUrl comes from snippets/login-url with the path left off, so it
       already ends in the right parameter for this store's kind of account. */
    location.href = (opts.loginUrl || '/account/login?return_url=') +
      encodeURIComponent(location.pathname + location.search);
  }

  /* The save a shopper asked for before signing in. Made once, after the
     account's own list has loaded, so it lands on top of it rather than
     racing it — and never as a removal, whatever the list already holds. */
  function completePending() {
    var data = null;
    try {
      data = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
      sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {}
    if (!data || !data.handle || isSaved(data.handle)) return;
    toggleSave(data);
    paintSaves();
    renderSaved();
    toast(strings.saved || 'Saved');
    pushSave(data, true);
  }

  /* --- the buttons -------------------------------------------- */

  function paintSaves() {
    $$('[data-save]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(isSaved(btn.dataset.save)));
    });
  }

  function initSaves() {
    if (!opts.savesEnabled) return;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-save]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      /* The Remove button in the saved list carries the handle and nothing
         else, so the ids come from whatever the cache already holds. */
      var known = readSaves().filter(function (s) {
        return s.handle === btn.dataset.save;
      })[0] || {};
      var cents = parseInt(btn.dataset.priceCents, 10);

      var data = {
        handle: btn.dataset.save,
        productId: btn.dataset.productId || known.productId || '',
        variantId: btn.dataset.variantId || known.variantId || '',
        title: btn.dataset.title || known.title || '',
        url: btn.dataset.url || known.url || '',
        image: btn.dataset.image || known.image || '',
        price: btn.dataset.price || known.price || '',
        priceCents: isNaN(cents) ? known.priceCents : cents
      };

      if (!opts.signedIn) { signIn(data); return; }

      var added = toggleSave(data);

      /* The same product can carry two save controls — the rail line and the
         floating pill. Repaint every one of them, or the other stays dark
         and the customer thinks the press failed. */
      paintSaves();
      toast(added ? (strings.saved || 'Saved') : 'Removed from your saves');
      renderSaved();
      pushSave(data, added);
    });

    if (!opts.signedIn) writeSaves([]);
    paintSaves();
    renderSaved();
    if (opts.signedIn) pullSaves(completePending);
    /* Safari's back button restores the page as it was left, saves and all:
       a save made on another page would show unsaved here until a reload. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      paintSaves();
      renderSaved();
      if (opts.signedIn) pullSaves();
    });
  }

  function renderSaved() {
    /* The saves row hides itself when there is nothing in it — a heading over
       an empty strip reads as something failing to load. */
    var row = $('[data-saves-row]');
    if (row) row.hidden = readSaves().length === 0;

    renderSavedLink();

    var host = $('#saved-list');
    if (!host) return;

    var list = readSaves();
    var emptyNote = $('#saved-empty');

    var count = $('[data-saves-count]');
    if (count) {
      count.hidden = !list.length;
      count.textContent = list.length + (list.length === 1 ? ' item' : ' items');
    }

    /* The Saves page asks for the fuller card: See details under the price
       and Add to Bag, the way the Apple Store app does it. Without a variant
       id there is nothing to add, so that card keeps Continue. */
    if (host.hasAttribute('data-buy')) {
      if (!list.length) { host.innerHTML = ''; if (emptyNote) emptyNote.hidden = false; return; }
      if (emptyNote) emptyNote.hidden = true;
      host.innerHTML = list.map(function (s) {
        var img = s.image
          ? '<a href="' + esc(s.url) + '" tabindex="-1"><img src="' + esc(s.image) + '" alt="' + esc(s.title) + '" loading="lazy"></a>'
          : '<div class="ph" style="width:160px;aspect-ratio:16/9;background:var(--bg)"></div>';
        var buy = s.variantId
          ? '<form action="/cart/add" method="post">' +
              '<input type="hidden" name="id" value="' + esc(s.variantId) + '">' +
              '<input type="hidden" name="quantity" value="1">' +
              '<button type="submit" class="btn">Add to bag</button></form>'
          : '<a class="btn" href="' + esc(s.url) + '">Continue</a>';
        return '' +
          '<div class="savedcard">' + img +
          '<div class="sb">' +
          '<div class="t21">' + esc(s.title) + '</div>' +
          '<p class="sp">' + esc(s.price) + '</p>' +
          '<a class="sdet" href="' + esc(s.url) + '">See details</a>' +
          '<div class="sa">' + buy +
          '<button type="button" class="rm" data-save="' + esc(s.handle) + '">Remove</button>' +
          '</div></div></div>';
      }).join('');
      return;
    }

    if (!list.length) {
      host.innerHTML = '';
      if (emptyNote) emptyNote.hidden = false;
      return;
    }
    if (emptyNote) emptyNote.hidden = true;

    host.innerHTML = list.map(function (s) {
      var img = s.image
        ? '<img src="' + esc(s.image) + '" alt="' + esc(s.title) + '" loading="lazy">'
        : '<div class="ph" style="width:168px;aspect-ratio:16/9;background:var(--panel)"></div>';
      return '' +
        '<div class="savedcard">' + img +
        '<div class="sb">' +
        '<div class="t21">' + esc(s.title) + '</div>' +
        '<p class="sp">' + esc(s.price) + '</p>' +
        '<div class="sa">' +
        '<a class="btn" href="' + esc(s.url) + '">Continue</a>' +
        '<button type="button" class="rm" data-save="' + esc(s.handle) + '">Remove</button>' +
        '</div></div></div>';
    }).join('');
  }

  /* For You's one-line pointer at the list: first picture, count, chevron. */
  function renderSavedLink() {
    var link = $('[data-saved-link]');
    if (!link) return;
    var list = readSaves();
    var first = list[0] || {};
    var pic = link.querySelector('[data-saved-link-img]');
    if (pic) {
      pic.innerHTML = first.image
        ? '<img src="' + esc(first.image) + '" alt="" loading="lazy">'
        : '<span class="ph"></span>';
    }
    var c = link.querySelector('[data-saved-link-count]');
    if (c) c.textContent = list.length + (list.length === 1 ? ' item' : ' items');
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ------------------------------------------------------------
     The photo wash: the same image, blurred, behind the copy
     ------------------------------------------------------------ */
  function initWash() {
    $$('[data-wash]').forEach(function (el) {
      var box = el.closest('.wash');
      var img = box && box.querySelector('img');
      if (img) el.style.setProperty('--wash-src', 'url("' + (img.currentSrc || img.src) + '")');
    });
  }

  /* ------------------------------------------------------------
     Hero trailer. Chrome ignores the autoplay attribute until a site
     has engagement, so ask once, in code. A refusal is fine — the
     poster is the product photograph, not a black frame.
     ------------------------------------------------------------ */
  /* ---------- hero rotation ----------
     The hero cycles the Featured collection. Only the visible slide's video
     plays: five autoplaying videos in one band is a lot of bandwidth for four
     pictures nobody is looking at. Rotation yields to the person — it stops
     on hover and on keyboard focus, and never runs at all for a visitor who
     has asked for reduced motion. */
  function initHeroSlides() {
    $$('[data-hero-slides]').forEach(function (frame) {
      var slides = $$('[data-hero-slide]', frame);
      if (slides.length < 2) { playOnly(slides, 0); return; }

      var dots = $$('[data-hero-dot]', frame);
      var index = 0;
      var timer = null;
      var held = false;

      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var wants = frame.dataset.autoplay === '1' && !still;
      var every = parseInt(frame.dataset.interval, 10) || 7000;

      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          var on = i === index;
          s.classList.toggle('is-on', on);
          if (on) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
        });
        /* Tabs and dots both carry data-hero-dot; each names its own slide. */
        dots.forEach(function (d) {
          var on = parseInt(d.dataset.heroDot, 10) === index;
          if (on) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
          d.classList.remove('is-run');
          if (on) { void d.offsetWidth; d.classList.add('is-run'); }
        });
        var count = frame.querySelector('[data-hero-count]');
        if (count) count.textContent = String(index + 1);
        playOnly(slides, index);
      }

      function playOnly(all, active) {
        all.forEach(function (s, i) {
          var v = s.querySelector('video');
          if (!v) return;

          /* Mark it visible only while it is genuinely running; the still
             behind it covers every other state. */
          if (!v.dataset.fadeBound) {
            v.dataset.fadeBound = '1';
            v.addEventListener('playing', function () { v.setAttribute('data-playing', ''); });
            ['pause', 'ended', 'emptied', 'stalled'].forEach(function (e) {
              v.addEventListener(e, function () { v.removeAttribute('data-playing'); });
            });
          }
          /* Start and loop from the performance, not the logo (data-start,
             from custom.trailer_start or the section's default skip). The
             native loop would go back to 0:00, so a trailer with a start
             loops by hand. */
          var from = parseFloat(v.dataset.start) || 0;
          var upto = parseFloat(v.dataset.end) || 0;
          if (upto > from && !v.dataset.endBound) {
            v.dataset.endBound = '1';
            v.addEventListener('timeupdate', function () { if (v.currentTime >= upto) v.currentTime = from; });
          }
          if (from > 0 && !v.dataset.startBound) {
            v.dataset.startBound = '1';
            v.loop = false;
            var seekStart = function () {
              if (v.duration && from < v.duration - 1 && v.currentTime < from - 0.5) v.currentTime = from;
            };
            v.addEventListener('loadedmetadata', seekStart);
            v.addEventListener('play', seekStart);
            v.addEventListener('ended', function () { v.currentTime = from; v.play().catch(function () {}); });
          }
          if (i === active) {
            /* Clips wait until the page itself has loaded, so the poster (the
               LCP image) never shares the line with a video, and slow or
               data-saver connections keep the still. */
            if (!window.tomsMediaOK) return;
            window.tomsMediaReady.then(function () {
              if (!s.classList.contains('is-on') && all.length > 1) return;
              if (v.preload === 'none') v.preload = 'metadata'; /* stream as it plays, don't buffer the whole file */
              var go = v.play();
              if (go && go.catch) { go.catch(function () { /* refused — the poster stands in */ }); }
            });
          } else if (!v.paused) {
            v.pause();
          }
        });
      }

      function start() {
        if (!wants || timer || held) return;
        timer = setInterval(function () { show(index + 1); }, every);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(parseInt(d.dataset.heroDot, 10)); stop(); start(); });
      });
      var prev = frame.querySelector('[data-hero-prev]');
      var next = frame.querySelector('[data-hero-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); stop(); start(); });
      if (next) next.addEventListener('click', function () { show(index + 1); stop(); start(); });
      /* The current tab's top edge fills over one slide's time. */
      frame.style.setProperty('--hero-every', every + 'ms');
      if (!wants) frame.classList.add('is-manual');

      /* Hold while someone is reading or tabbing through it. */
      ['mouseenter', 'focusin'].forEach(function (e) {
        frame.addEventListener(e, function () { held = true; stop(); frame.classList.add('is-held'); });
      });
      ['mouseleave', 'focusout'].forEach(function (e) {
        frame.addEventListener(e, function () {
          if (e === 'focusout' && frame.contains(document.activeElement)) return;
          held = false; frame.classList.remove('is-held');
          /* The pause restarts the slide's clock, so the fill starts over too. */
          show(index); start();
        });
      });

      /* A background tab should not burn through slides. */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });

      show(0);
      start();
    });
  }

  /* ---------- phone buy bar and quick actions ----------
     The bar is revealed only once the rail's own button has left the screen,
     so the page never shows two identical blue buttons at the same time. */
  function initBuyBar() {
    var bar = $('[data-buybar]');
    if (bar) {
      /* The card lives in the page under the gallery (Rich, 2026-10-06) and
         only floats once it has scrolled off the top - before that it is
         simply part of the page, not chrome sitting on top of it. The slot
         keeps the card's height while it floats, so the page does not jump. */
      var slot = bar.closest('[data-bbslot]');
      bar.hidden = false;
      bar.setAttribute('aria-hidden', 'false');
      if (slot && 'IntersectionObserver' in window && !slot.dataset.watch) {
        slot.dataset.watch = '1';
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            if (past === slot.classList.contains('is-floating')) return;
            if (past) {
              slot.style.minHeight = slot.offsetHeight + 'px';
              slot.classList.add('is-floating');
            } else {
              slot.classList.remove('is-floating');
              slot.style.minHeight = '';
            }
          });
        }).observe(slot);
      }
      /* Near the footer the floating card would sit on the footer's links, so
         it steps aside once the footer is on screen. */
      var foot = document.querySelector('footer');
      if (slot && foot && 'IntersectionObserver' in window && !foot.dataset.bbwatch) {
        foot.dataset.bbwatch = '1';
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { slot.classList.toggle('at-foot', entry.isIntersecting); });
        }).observe(foot);
      }

      var head = bar.querySelector('[data-buybar-toggle]');
      var details = head && document.getElementById(head.getAttribute('aria-controls'));
      /* init can run again on a section re-render; without this the toggle
         binds twice and every tap flips the panel back to where it was. */
      if (head && details && !head.dataset.bound) {
        head.dataset.bound = '1';
        head.addEventListener('click', function () {
          var open = head.getAttribute('aria-expanded') === 'true';
          head.setAttribute('aria-expanded', String(!open));
          details.hidden = open;
        });
      }
    }

    /* The from-price pill leads to the options it is asking you to pick. */
    document.addEventListener('click', function (e) {
      var j = e.target.closest('[data-jump-options]');
      if (!j) return;
      e.preventDefault();
      var opts = $('.buyrail .variants');
      if (opts) opts.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });

    /* Back: history where this tab has some, the real href otherwise. A
       chevron that dead-ends on a link opened cold is worse than a
       breadcrumb. */
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-back]');
      if (!b) return;
      var sameTab = window.history.length > 1 &&
        document.referrer && document.referrer.indexOf(window.location.origin) === 0;
      if (sameTab) { e.preventDefault(); window.history.back(); }
    });

    /* Share: the OS sheet where there is one, the clipboard where there is
       not. Never a dead button. Bound once per document, for the same reason
       the toggle above is. */
    if (document.documentElement.dataset.shareBound) return;
    document.documentElement.dataset.shareBound = '1';
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-share]');
      if (!btn) return;
      e.preventDefault();
      var url = btn.dataset.shareUrl || window.location.href;
      var title = btn.dataset.shareTitle || document.title;

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () { /* dismissed */ });
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url)
          .then(function () { toast(strings.linkCopied || 'Link copied'); })
          .catch(function () { toast(url); });
        return;
      }
      toast(url);
    });
  }

  function initHeroVideo() {
    $$('[data-hero-video]').forEach(function (v) {
      if (v.dataset.nudged) return;
      v.dataset.nudged = '1';
      v.muted = true;

      /* If someone pauses it themselves, leave it paused. */
      var userPaused = false;
      v.addEventListener('pause', function () {
        if (v.dataset.auto === '1') { v.dataset.auto = ''; return; }
        userPaused = true;
      });
      v.addEventListener('play', function () { userPaused = false; });

      function nudge() {
        if (userPaused || !window.tomsMediaOK) return;
        if (!window.tomsMediaLoaded) { window.tomsMediaReady.then(nudge); return; }
        var attempt = v.play();
        if (attempt && attempt.catch) {
          attempt.catch(function () { /* refused — the poster stands in */ });
        }
      }

      /* Asking once at load is too early: the element often has no data yet
         and the call is a no-op. Chrome also throttles autoplay for media it
         does not consider visible, so playback follows the viewport. */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              nudge();
            } else if (!v.paused) {
              v.dataset.auto = '1';
              v.pause();
            }
          });
        }, { threshold: 0.25 }).observe(v);
      } else {
        nudge();
      }

      v.addEventListener('canplay', nudge, { once: true });
      v.addEventListener('loadeddata', nudge, { once: true });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) nudge();
      });
    });
  }

  /* ------------------------------------------------------------
     Back in stock.

     Klaviyo's Back in Stock subscription is what actually watches inventory
     and sends the email. It subscribes against a catalog variant, so it only
     works once the Shopify catalogue is synced into Klaviyo.

     The event is sent either way. It needs no catalogue, so the demand is
     recorded even when the subscription is refused — and if both calls fail
     the customer is told, rather than shown a confirmation that isn't true.
     ------------------------------------------------------------ */
  var KLAVIYO = 'https://a.klaviyo.com/client/';
  var KLAVIYO_REVISION = '2024-10-15';

  function klaviyoPost(path, payload) {
    var key = (MS.notify && MS.notify.klaviyoKey) || '';
    if (!key) return Promise.reject(new Error('No Klaviyo key configured'));

    return fetch(KLAVIYO + path + '/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) {
        return r.text().then(function (t) { throw new Error(path + ' ' + r.status + ' ' + t.slice(0, 180)); });
      }
      return true;
    });
  }
  /* Shared with find-the-lady.js, so both sign-ups build Klaviyo client calls
     one way (same revision header, same company_id). */
  MS.klaviyoPost = klaviyoPost;

  function backInStockSubscribe(email, variantId) {
    return klaviyoPost('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: {
            /* Klaviyo's Shopify integration uses this id shape for variants. */
            data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
          }
        }
      }
    });
  }

  function backInStockEvent(email, info) {
    return klaviyoPost('events', {
      data: {
        type: 'event',
        attributes: {
          properties: {
            ProductName: info.title,
            ProductHandle: info.handle,
            VariantId: String(info.variantId || ''),
            VariantTitle: info.variantTitle || '',
            URL: window.location.origin + '/products/' + info.handle
          },
          metric: { data: { type: 'metric', attributes: { name: 'Back in Stock Requested' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }
      }
    });
  }

  function initNotify() {
    var modal = $('#nmodal');
    if (!modal || !MS.notify || !MS.notify.enabled) return;

    var titleEl = $('#ntitle'), subEl = $('#nsub');
    var ask = $('#nask'), done = $('#ndone'), doneText = $('#ndonetext');
    var emailEl = $('#nemail'), errEl = $('#nerror'), submit = $('#nsubmit');
    var current = null, opener = null;

    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (opener) opener.focus();
    }

    function showError(msg) { errEl.textContent = msg; errEl.hidden = false; }

    function open(handle, title, variantId, trigger) {
      opener = trigger || null;
      current = { handle: handle, title: title, variantId: variantId };
      titleEl.textContent = title || '';
      subEl.textContent = MS.strings.notifySub || '';
      ask.hidden = false; done.hidden = true;
      errEl.hidden = true;
      submit.disabled = false;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (!emailEl.value) emailEl.focus();
    }

    /* Every out-of-stock variant, for when no single option was chosen. */
    function allGoneVariants(handle) {
      return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          return p.variants.filter(function (v) { return !v.available; }).map(function (v) { return v.id; });
        })
        .catch(function () { return []; });
    }

    $$('[data-notify]').forEach(function () {}); /* delegated below */

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-notify]');
      if (t) {
        e.preventDefault();
        e.stopPropagation();
        open(t.dataset.notify, t.dataset.notifyTitle, t.dataset.notifyVariant, t);
        return;
      }
      if (e.target.closest('[data-nclose]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    submit.addEventListener('click', function () {
      var email = (emailEl.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        showError(MS.strings.notifyBadEmail || 'Enter a valid email address.');
        emailEl.focus();
        return;
      }

      errEl.hidden = true;
      submit.disabled = true;
      var label = submit.textContent;
      submit.textContent = '…';

      /* The choice lives on the product page. "all" — or arriving from a
         collection card, where there is nothing to choose — subscribes to
         every out-of-stock variant, so any one returning sends the email. */
      var pagePick = $('#pdp-notify-variant');
      var picked = pagePick ? pagePick.value : (current.variantId || 'all');
      var pickedLabel = pagePick && pagePick.value !== 'all'
        ? pagePick.options[pagePick.selectedIndex].textContent.trim() : '';
      var isAny = (picked === 'all' || !picked);

      var idsPromise = isAny ? allGoneVariants(current.handle) : Promise.resolve([picked]);

      idsPromise.then(function (ids) {
        var subscribed = ids.length
          ? Promise.all(ids.map(function (id) {
              return backInStockSubscribe(email, id).then(function () { return true; }).catch(function () { return false; });
            })).then(function (results) { return results.some(Boolean); })
          : Promise.resolve(false);

        var recorded = backInStockEvent(email, {
          title: current.title, handle: current.handle,
          variantId: ids.join(','), variantTitle: pickedLabel || 'Any option'
        }).then(function () { return true; }).catch(function () { return false; });

        return Promise.all([subscribed, recorded]);
      }).then(function (r) {
        submit.disabled = false;
        submit.textContent = label;

        if (!r[0] && !r[1]) {
          showError((MS.strings.notifyFailed || 'Could not save that. Email {{ contact }}.')
            .replace('{{ contact }}', MS.notify.contact || ''));
          return;
        }

        subEl.textContent = MS.strings.notifyDoneSub || '';
        titleEl.textContent = MS.strings.notifyDoneTitle || '';
        var template = isAny ? (MS.strings.notifyDoneAny || MS.strings.notifyDone) : MS.strings.notifyDone;
        doneText.textContent = (template || '')
          .replace('{{ email }}', email)
          .replace('{{ product }}', isAny ? current.title : (pickedLabel || current.title));
        ask.hidden = true;
        done.hidden = false;
        announce(doneText.textContent);
      });
    });
  }

  /* ------------------------------------------------------------
     Money. The product .js endpoint returns raw cents, so the shop's own
     money_format is applied here rather than guessing at a currency symbol.
     ------------------------------------------------------------ */
  function formatMoney(cents) {
    var fmt = MS.moneyFormat || '${{amount}}';

    function build(decimals, thousands, decimalMark) {
      var n = (Number(cents) || 0) / 100;
      var parts = n.toFixed(decimals).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimalMark + parts[1] : whole;
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount_no_decimals':                     return build(0, ',', '.');
        case 'amount_with_comma_separator':            return build(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':return build(0, '.', ',');
        case 'amount_with_apostrophe_separator':       return build(2, "'", '.');
        default:                                       return build(2, ',', '.');
      }
    });
  }

  /* Shared, because wallet.js needs the same shape. Two money formatters in
     one theme is one that drifts, and a balance formatted differently from
     the price beside it reads as a different kind of money. */
  MS.formatMoney = formatMoney;
  /* The gift card page adds a line with recipient properties, which the
     click handler above does not carry; it reuses the same request so the
     drawer refreshes exactly as it does everywhere else. */
  MS.addItems = addItems;

  /* ------------------------------------------------------------
     Option chooser. Opens for any product with more than one variant,
     so nothing is ever added to a bag without the option being picked.
     ------------------------------------------------------------ */
  function initChooser() {
    var modal = $('#vmodal');
    if (!modal) return;

    var titleEl = $('#vtitle');
    var optsEl = $('#vopts');
    var addBtn = $('#vadd');
    var chosen = null;
    var opener = null;

    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (opener) opener.focus();
    }

    function open(handle, title, trigger) {
      opener = trigger || null;
      chosen = null;
      titleEl.textContent = title || '';
      optsEl.innerHTML = '<p class="cap muted">…</p>';
      addBtn.disabled = true;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';

      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('Could not load options');
          return r.json();
        })
        .then(function (p) {
          titleEl.textContent = p.title;
          optsEl.innerHTML = '';

          p.variants.forEach(function (v) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'vopt';
            b.setAttribute('role', 'radio');
            b.setAttribute('aria-checked', 'false');
            b.dataset.variantId = v.id;
            if (!v.available) b.disabled = true;

            var price = '<span class="vprice">';
            if (v.compare_at_price && v.compare_at_price > v.price) {
              price += '<span class="was">' + esc(formatMoney(v.compare_at_price)) + '</span>';
            }
            price += esc(Number(v.price) === 0 ? (MS.freeLabel || 'Free') : formatMoney(v.price)) + '</span>';

            b.innerHTML = '<span class="vname">' + esc(v.title) + '</span>' +
              (v.available ? price : '<span class="vgone">' + esc(strings.soldOut || 'Sold out') + '</span>');

            b.addEventListener('click', function () {
              if (b.disabled) return;
              $$('.vopt', optsEl).forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
              b.setAttribute('aria-checked', 'true');
              chosen = v.id;
              addBtn.disabled = false;
            });

            optsEl.appendChild(b);
          });

          /* Preselect the first option that can actually be bought. */
          var first = optsEl.querySelector('.vopt:not([disabled])');
          if (first) first.click();
          if (first) first.focus();
        })
        .catch(function () {
          optsEl.innerHTML = '<p class="cap muted">Options could not be loaded. Open the product page instead.</p>';
        });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-choose]');
      if (trigger) {
        e.preventDefault();
        open(trigger.dataset.choose, trigger.dataset.chooseTitle, trigger);
        return;
      }
      if (e.target.closest('[data-vclose]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    addBtn.addEventListener('click', function () {
      if (!chosen) return;
      addToCart(chosen, 1, addBtn).then(function () { close(); });
    });
  }

  /* ------------------------------------------------------------
     The trailer section. Nobody's bandwidth is spent until they ask:
     preload is none, and the first click loads, unmutes and plays.
     ------------------------------------------------------------ */
  function initTrailer() {
    $$('[data-video]').forEach(function (frame) {
      var btn = frame.querySelector('[data-play]');
      var v = frame.querySelector('[data-trailer]');
      if (!btn || !v) return;

      btn.addEventListener('click', function () {
        v.muted = false;
        v.controls = true;
        frame.classList.add('playing');
        var attempt = v.play();
        if (attempt && attempt.catch) {
          attempt.catch(function () {
            /* Some browsers refuse audio on a first play; fall back to muted
               rather than leaving the viewer with a dead button. */
            v.muted = true;
            v.play().catch(function () { frame.classList.remove('playing'); });
          });
        }
      });
    });
  }

  /* ------------------------------------------------------------
     Product media thumbnails
     ------------------------------------------------------------ */
  /* One track, two behaviours. With a pointer the thumbnails choose which
     slide is displayed; on a phone the track scrolls and the dots follow it.
     The dots are driven by scroll position rather than by taps, so a swipe
     and a tap cannot disagree about where you are. */
  /* A generic sideways scroller: the arrows move by roughly a screenful and
     disable themselves at the ends, so a row that has nowhere left to go says
     so rather than swallowing the tap. */

  function initScrollers() {
    $$('[data-scroller]').forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';

      var track = wrap.hasAttribute('data-scroller-track') ? wrap : wrap.querySelector('[data-scroller-track]') || wrap;
      var host = track.closest('.mtrackwrap, .extrackwrap') || wrap.closest('section') || document;
      var prev = host.querySelector('[data-scroll-prev]');
      var next = host.querySelector('[data-scroll-next]');

      /* Every sideways row gets the hover arrows, including ones whose
         section never drew any (the category coins, the benefit strip, and
         whatever gets added next). The row is wrapped in the same
         .mtrackwrap the shelves use, so the arrows look and behave the same
         everywhere: hidden until hover, gone at either end, gone entirely
         when the row fits. */
      if (!prev && !next) {
        var shell = document.createElement('div');
        shell.className = 'mtrackwrap snavhost';
        track.parentNode.insertBefore(shell, track);
        shell.appendChild(track);
        /* Borrow the translated labels from any arrow the theme rendered. */
        var p0 = document.querySelector('[data-scroll-prev][aria-label]');
        var n0 = document.querySelector('[data-scroll-next][aria-label]');
        var label = {
          prev: p0 ? p0.getAttribute('aria-label') : 'Previous',
          next: n0 ? n0.getAttribute('aria-label') : 'Next'
        };
        prev = document.createElement('button');
        next = document.createElement('button');
        [[prev, 'prev', 'M7 1L1 7l6 6'], [next, 'next', 'M1 1l6 6-6 6']].forEach(function (b) {
          b[0].type = 'button';
          b[0].className = 'snav snav--' + b[1];
          b[0].setAttribute('aria-label', label[b[1]]);
          b[0].innerHTML = '<svg viewBox="0 0 8 14" fill="none" aria-hidden="true"><path d="' + b[2] + '" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          shell.appendChild(b[0]);
        });
      }

      /* Arrows on a row that fits are furniture: both ends are already in
         view, so both buttons are permanently disabled and the pair just
         takes up space under the cards. Whether a track overflows depends on
         the window, so it cannot be decided in Liquid. */
      var nav = (prev || next).closest('.scrollnavwrap') || (prev || next).closest('.scrollnav');

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        if (nav) nav.hidden = track.scrollWidth - track.clientWidth <= 4;
      }

      function step(dir) {
        track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.8), behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* Filtering works as a plain form submit; this only makes it feel immediate:
     a change applies itself, one menu is open at a time, and a long list can
     be narrowed by typing. The Apply buttons are CSS-hidden once .js is on the
     root, so nothing here is load-bearing. */
  function initFilters() {
    var form = $('[data-filter-form]');
    if (!form || form.dataset.bound) return;
    form.dataset.bound = '1';

    function submit() {
      /* The carried hidden inputs exist for the no-script path; with a real
         submit they would double every ticked box. */
      $$('[data-carried]', form).forEach(function (el) { el.disabled = true; });
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-filter-search]')) return;
      submit();
    });

    /* Typing a price is not a decision until you stop typing. */
    var t = null;
    form.addEventListener('input', function (e) {
      if (e.target.type !== 'number') return;
      clearTimeout(t);
      t = setTimeout(submit, 700);
    });

    $$('[data-filter-search]', form).forEach(function (box) {
      box.addEventListener('input', function () {
        var needle = box.value.trim().toLowerCase();
        var menu = box.closest('.fmenu');
        $$('[data-filter-option]', menu).forEach(function (opt) {
          var name = (opt.querySelector('.fname') || {}).textContent || '';
          opt.hidden = needle !== '' && name.toLowerCase().indexOf(needle) === -1;
        });
      });
    });

    var pills = $$('[data-filter-pill]');
    pills.forEach(function (pill) {
      pill.addEventListener('toggle', function () {
        if (!pill.open) return;
        pills.forEach(function (other) { if (other !== pill) other.open = false; });
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-pill]')) return;
      pills.forEach(function (p) { p.open = false; });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      pills.forEach(function (p) { p.open = false; });
    });
  }

  /* Appearance: system, light, dark — in that cycle.
     "System" is not a third opinion, it is the absence of one: nothing saved
     and no attribute on the root, so the CSS media query decides and keeps
     deciding as the phone changes through the day. A two-state toggle looked
     complete but stranded anyone who pressed it — there was no way back to
     following the device short of clearing site data. */
  function initTheme() {
    var KEY = 'magicstore:theme';
    var ORDER = ['system', 'light', 'dark'];
    var root = document.documentElement;
    var media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

    function saved() {
      try { return localStorage.getItem(KEY); } catch (e) { return null; }
    }

    function mode() {
      var m = saved();
      return m === 'light' || m === 'dark' ? m : 'system';
    }

    function apply(next) {
      if (next === 'system') {
        try { localStorage.removeItem(KEY); } catch (e) {}
        root.removeAttribute('data-theme');
      } else {
        try { localStorage.setItem(KEY, next); } catch (e) {}
        root.setAttribute('data-theme', next);
      }
      paint();
    }

    function paint() {
      var m = mode();
      $$('[data-theme-toggle]').forEach(function (b) {
        b.dataset.mode = m;
        b.setAttribute('aria-label', strings['theme' + m.charAt(0).toUpperCase() + m.slice(1)] || m);
      });
    }

    $$('[data-theme-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        apply(ORDER[(ORDER.indexOf(mode()) + 1) % ORDER.length]);
      });
    });

    /* Only meaningful while they are still on system; once they have chosen,
       the device changing underneath them must not move the page. */
    if (media && media.addEventListener) {
      media.addEventListener('change', function () { if (!saved()) paint(); });
    }

    paint();
  }

  /* Currency applies on change. The form posts and the page reloads in the new
     market — there is no client-side way to reprice a catalogue, and pretending
     otherwise would show stale prices next to a changed currency. */
  function initCurrency() {
    $$('[data-currency-select]').forEach(function (sel) {
      if (sel.dataset.bound) return;
      sel.dataset.bound = '1';
      sel.addEventListener('change', function () {
        var form = sel.closest('form');
        if (!form) return;
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      });
    });
  }

  /* ------------------------------------------------------------
     Photo viewer (snippets/gallery-zoom). Any [data-zoom-open] tile, or a
     still in a stills-only frame, opens it at that picture. The track is a
     scroll-snap row, so a phone swipes it natively; the arrows and the
     counter follow the scroll rather than keeping a count of their own,
     so a swipe and a press can never disagree. The phone's back gesture
     closes it — on a full-screen layer that is what back means, and
     without the history entry it would leave the product page instead.
     ------------------------------------------------------------ */
  function initZoom() {
    $$('[data-gallery]').forEach(function (gal) {
      var dlg = gal.querySelector('[data-zoom]');
      if (!dlg || dlg.dataset.bound || typeof dlg.showModal !== 'function') return;
      dlg.dataset.bound = '1';

      var track = dlg.querySelector('[data-zoom-track]');
      var items = $$('[data-zoom-item]', dlg);
      var count = dlg.querySelector('[data-zoom-count]');
      var prev = dlg.querySelector('[data-zoom-prev]');
      var next = dlg.querySelector('[data-zoom-next]');
      var pushed = false;

      function current() {
        var w = track.clientWidth || 1;
        return Math.max(0, Math.min(items.length - 1, Math.round(track.scrollLeft / w)));
      }
      /* The viewer's photos are lazy, and a swipe outruns lazy loading: ask
         for the neighbours as soon as a photo is showing. */
      function warm(i) {
        [i - 1, i, i + 1].forEach(function (n) {
          var img = items[n] && items[n].querySelector('img');
          if (img && img.loading === 'lazy') img.loading = 'eager';
        });
      }
      function sync() {
        var i = current();
        warm(i);
        if (count) count.textContent = (i + 1) + ' / ' + items.length;
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === items.length - 1;
      }
      function go(i, smooth) {
        i = Math.max(0, Math.min(items.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
        if (!smooth) sync();
      }
      /* A spotlight, not a takeover (Rich, 2026-09-27): the photo is never
         bigger than the video frame it came from. Measured at open, because
         the frame's size depends on the window and on which clip is showing;
         the picture is then contained inside that box. */
      function frameBox() {
        var frame = gal.querySelector('[data-gallery-track]');
        var r = frame ? frame.getBoundingClientRect() : null;
        var w = r && r.width ? r.width : Math.min(window.innerWidth - 24, 900);
        var h = r && r.height ? r.height : w * 9 / 16;
        /* Room for the close button above and the controls below. */
        var room = window.innerHeight - 160;
        if (h > room) { w = w * room / h; h = room; }
        dlg.style.setProperty('--zw', Math.round(w) + 'px');
        dlg.style.setProperty('--zh', Math.round(h) + 'px');
      }
      function open(i) {
        if (dlg.open) return;
        frameBox();
        dlg.showModal();
        document.documentElement.classList.add('zoom-open');
        /* The track has no width until the dialog is shown. */
        requestAnimationFrame(function () { go(i, false); });
        try { history.pushState({ zoom: true }, ''); pushed = true; } catch (e) { pushed = false; }
      }
      function close() { if (dlg.open) dlg.close(); }

      dlg.addEventListener('close', function () {
        document.documentElement.classList.remove('zoom-open');
        /* Closed by the button or Esc: take back the history entry we added,
           so back afterwards leaves the page as the shopper expects. */
        if (pushed) { pushed = false; if (history.state && history.state.zoom) history.back(); }
      });
      window.addEventListener('popstate', function () {
        if (dlg.open) { pushed = false; dlg.close(); }
      });

      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', function () { if (dlg.open) { frameBox(); go(current(), false); } });
      if (prev) prev.addEventListener('click', function () { go(current() - 1, true); });
      if (next) next.addEventListener('click', function () { go(current() + 1, true); });
      dlg.querySelector('[data-zoom-close]').addEventListener('click', close);
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1, true); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1, true); }
      });
      /* A tap on the dark around the picture closes it, as it does everywhere
         else; a tap on the picture itself does not. */
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target === track || e.target.hasAttribute('data-zoom-item')) close();
      });

      $$('[data-zoom-open]', gal).forEach(function (btn) {
        btn.addEventListener('click', function () { open(parseInt(btn.dataset.zoomOpen, 10) || 0); });
      });

      /* A stills-only frame: its slides are the images, in the same order. */
      if (!gal.classList.contains('media-col--video')) {
        var n = 0;
        $$('[data-gallery-slide]', gal).forEach(function (sl) {
          var img = sl.querySelector('img');
          if (!img || sl.querySelector('video, iframe, template, model-viewer')) return;
          var i = n++;
          sl.classList.add('is-zoomable');
          img.addEventListener('click', function () { open(i); });
        });
      }
    });
  }

  function initGallery() {
    $$('[data-gallery]').forEach(function (gal) {
      if (gal.dataset.bound) return;
      gal.dataset.bound = '1';

      var track = gal.querySelector('[data-gallery-track]');
      var slides = $$('[data-gallery-slide]', gal);
      var thumbs = $$('[data-gallery-thumb]', gal);
      var dots = $$('[data-gallery-dot]', gal);
      /* Play controls are bound before the one-slide exit below: a product
         with a single video (its trailer and nothing else) used to return
         here first, so its play button did nothing and the poster never
         lifted. */
      /* Play buttons: a native video just plays; a YouTube facade swaps its
         poster for the real embed the first time it is asked, so nobody loads
         a third-party player they never pressed. */
      $$('[data-play]', gal).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var wrap = btn.closest('[data-media-video], [data-media-embed]');
          if (!wrap) return;
          var tpl = wrap.querySelector('template[data-embed]');
          if (tpl) {
            wrap.insertBefore(tpl.content.cloneNode(true), tpl);
            var img = wrap.querySelector('img');
            if (img) img.remove();
            tpl.remove();
            btn.hidden = true;
            return;
          }
          var v = wrap.querySelector('video');
          if (v) { v.play(); btn.hidden = true; wrap.classList.add('is-playing'); }
          gal.classList.add('is-playing');
        });
      });

      $$('video', gal).forEach(function (v) {
        v.addEventListener('play', function () {
          var wrap = v.closest('[data-media-video]');
          var btn = wrap && wrap.querySelector('[data-play]');
          if (btn) btn.hidden = true;
          if (wrap) wrap.classList.add('is-playing');
          gal.classList.add('is-playing');
        });
        v.addEventListener('pause', function () {
          var wrap = v.closest('[data-media-video]');
          var btn = wrap && wrap.querySelector('[data-play]');
          if (btn && v.currentTime === 0) btn.hidden = false;
          /* Pausing brings the thumbnail strip back into the frame. */
          gal.classList.remove('is-playing');
        });
      });

      /* gallery:media comes from a variant choice. A slide in the frame is
         moved to; a still in the roll under a video is scrolled into view. */
      var goSlide = null;
      document.addEventListener('gallery:media', function (e) {
        var id = e.detail && e.detail.id ? String(e.detail.id) : '';
        if (!id) return;
        for (var n = 0; n < slides.length; n++) {
          if (slides[n].getAttribute('data-media-id') === id) {
            if (goSlide) goSlide(n);
            return;
          }
        }
        var tile = gal.querySelector('.irollitem[data-media-id="' + id + '"]');
        var roll = tile && tile.closest('[data-scroller-track]');
        if (roll) roll.scrollTo({ left: tile.offsetLeft - roll.offsetLeft, behavior: 'smooth' });
      });

      if (!track || slides.length < 2) return;

      function markDots(i) {
        dots.forEach(function (d, n) {
          if (n === i) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
        });
      }

      /* Leaving a slide stops whatever was playing on it. Without this a
         trailer keeps talking from behind a still two thumbnails away. */
      function stopMedia(scope) {
        $$('video', scope).forEach(function (v) { if (!v.paused) v.pause(); });
        $$('iframe', scope).forEach(function (f) { f.src = f.src; });
        $$('[data-play]', scope).forEach(function (b) { b.hidden = false; });
        $$('[data-media-video]', scope).forEach(function (w) { w.classList.remove('is-playing'); });
        gal.classList.remove('is-playing');
      }

      /* The track wears the active item's aspect ratio, which is what keeps
         it wrapped tight to the frame. */
      function wearShape(sl) {
        if (!sl || !track) return;
        var w = sl.style.getPropertyValue('--arw');
        var h = sl.style.getPropertyValue('--arh');
        if (w && h) { track.style.setProperty('--arw', w); track.style.setProperty('--arh', h); }
      }

      function showSlide(i) {
        wearShape(slides[i]);
        slides.forEach(function (sl, n) {
          var on = n === i;
          if (!on && sl.classList.contains('is-on')) stopMedia(sl);
          sl.classList.toggle('is-on', on);
        });
        thumbs.forEach(function (t) { t.setAttribute('aria-current', String(thumbAt(t) === i)); });
        markDots(i);
      }

      /* A video product carries two sets of thumbnails — the corner strip and
         the phone's row under the frame — so a thumbnail's slide is its own
         data-gallery-thumb, not its position in the list. */
      function thumbAt(t) { return parseInt(t.getAttribute('data-gallery-thumb'), 10) || 0; }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { showSlide(thumbAt(t)); });
      });

      /* Slides are narrower than the track so the next one peeks, which means
         position cannot be derived from scrollLeft / trackWidth any more.
         Measure against the slides themselves and the answer stays right
         whatever the peek is set to. */
      function padLeft() {
        return parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
      }

      function nearestSlide() {
        var trackLeft = track.getBoundingClientRect().left + padLeft();
        var best = 0;
        var bestGap = Infinity;
        slides.forEach(function (sl, i) {
          var gap = Math.abs(sl.getBoundingClientRect().left - trackLeft);
          if (gap < bestGap) { bestGap = gap; best = i; }
        });
        return best;
      }

      /* Scrolling is the phone case; on desktop the track does not
         scroll, so fall back to swapping the visible slide. */
      goSlide = function (i) {
        if (track.scrollWidth > track.clientWidth + 4) {
          var trackLeft = track.getBoundingClientRect().left + padLeft();
          track.scrollBy({ left: slides[i].getBoundingClientRect().left - trackLeft, behavior: 'smooth' });
        } else {
          showSlide(i);
        }
      };
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { goSlide(i); });
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          markDots(nearestSlide());
        });
      }, { passive: true });
    });
  }

  /* ------------------------------------------------------------ */

  /* ------------------------------------------------------------
     Announcement bar and countdowns
     ------------------------------------------------------------ */

  /* One ticker for every clock on the page rather than one each, so ten
     countdowns cost the same as one and all of them change on the same
     second instead of drifting apart. */
  var clocks = [];
  var clockTimer = null;

  function fmtLeft(ms) {
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var m = Math.floor(s / 60);    s -= m * 60;
    /* Seconds are only useful once they are the thing you are waiting for.
       Four days and eleven seconds is noise; the last hour is not. */
    if (d > 0) return d + 'd ' + h + 'h ' + m + 'm';
    if (h > 0) return h + 'h ' + m + 'm ' + s + 's';
    return m + 'm ' + s + 's';
  }

  function tickClocks() {
    var now = Date.now();
    clocks = clocks.filter(function (c) {
      var left = c.end - now;
      if (left > 0) {
        c.out.textContent = fmtLeft(left);
        return true;
      }
      /* Past the deadline. Either say so, or take the message away —
         a bar still promising a finished sale is worse than no bar. */
      if (c.expired) {
        c.out.textContent = c.expired;
      } else {
        var msg = c.el.closest('[data-ann-msg]');
        if (msg) { msg.remove(); } else { c.el.remove(); }
        announceRotate();
      }
      return false;
    });
    if (!clocks.length && clockTimer) { clearInterval(clockTimer); clockTimer = null; }
  }

  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      var end = Date.parse(el.getAttribute('data-countdown'));
      var out = el.querySelector('[data-countdown-out]');
      if (!out || isNaN(end)) return;   /* leave the readable date in place */
      clocks.push({ el: el, out: out, end: end, expired: el.getAttribute('data-countdown-expired') || '' });
    });
    if (clocks.length) {
      tickClocks();
      if (!clockTimer) clockTimer = setInterval(tickClocks, 1000);
    }
  }

  function announceRotate() {
    $$('[data-announce]').forEach(function (bar) {
      var msgs = $$('[data-ann-msg]', bar);
      if (!msgs.length) { bar.remove(); return; }
      if (!msgs.some(function (m) { return !m.hidden; })) msgs[0].hidden = false;
    });
  }

  function initAnnounce() {
    $$('[data-announce]').forEach(function (bar) {
      if (bar.dataset.bound) return;
      bar.dataset.bound = '1';

      /* Keyed on the wording, not on the bar: a shopper who dismissed last
         month's notice should still see this month's. */
      var msgs = $$('[data-ann-msg]', bar);
      var key = 'magicstore:ann:' + (msgs.map(function (m) { return m.textContent.trim(); }).join('|').length
        + ':' + msgs.map(function (m) { return m.textContent.trim().slice(0, 24); }).join('|'));

      if (bar.hasAttribute('data-dismissible')) {
        try { if (localStorage.getItem(key) === '1') { bar.remove(); return; } } catch (e) {}
        var x = $('[data-ann-dismiss]', bar);
        if (x) x.addEventListener('click', function () {
          bar.remove();
          try {
            /* Only the current wording is worth remembering. Keeping a key per
               announcement the store has ever run would grow for ever. */
            Object.keys(localStorage).forEach(function (k) {
              if (k.indexOf('magicstore:ann:') === 0) localStorage.removeItem(k);
            });
            localStorage.setItem(key, '1');
          } catch (e) {}
        });
      }

      var secs = parseInt(bar.getAttribute('data-rotate'), 10) || 6;
      if (msgs.length < 2) return;
      var i = 0;
      setInterval(function () {
        var live = $$('[data-ann-msg]', bar);
        if (live.length < 2) return;
        live.forEach(function (m) { m.hidden = true; });
        i = (i + 1) % live.length;
        live[i].hidden = false;
      }, secs * 1000);
    });
  }

  /* --- More like this ------------------------------------------ */
  /* The section renders a fallback row from the product's category so the
     links are in the HTML. Swap in Shopify's recommendations when it has
     any; keep the fallback when it has none or the request fails. */
  /* The Shop dropdown opens on hover and on keyboard focus in CSS. Escape has
     to close it even while the pointer or focus is still inside, so it sets a
     shut flag that clears once the pointer leaves or focus moves out. */
  function initMega() {
    $$('[data-mega]').forEach(function (host) {
      if (host.dataset.bound) return;
      host.dataset.bound = '1';
      host.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        host.classList.add('is-shut');
        var top = host.querySelector('a');
        if (top) top.focus();
      });
      host.addEventListener('mouseleave', function () { host.classList.remove('is-shut'); });
      host.addEventListener('focusout', function (e) {
        if (!host.contains(e.relatedTarget)) host.classList.remove('is-shut');
      });
    });
  }

  /* On a phone the category row scrolls sideways, so on Downloads the pill
     you are on would sit off-screen. Scroll the row itself — not the page —
     until it is in view. */
  function initCatRow() {
    document.querySelectorAll('.pills--cat').forEach(function (row) {
      var here = row.querySelector('[aria-current="true"]');
      if (!here || row.scrollWidth <= row.clientWidth) return;
      var left = here.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft;
      row.scrollLeft = left - (row.clientWidth - here.offsetWidth) / 2;
    });
  }

  /* Phone product page, shorter (2026-10-06): a long overview shows its first
     lines with Read more, and the questions open one answer at a time. Phones
     only - the desktop page keeps everything laid out. */
  function initFold() {
    if (!window.matchMedia || !matchMedia('(max-width: 767px)').matches) return;
    $$('[data-clamp]').forEach(function (el) {
      if (el.dataset.folded || el.scrollHeight < 300) return;
      el.dataset.folded = '1';
      el.classList.add('is-clamped');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'readmore';
      b.textContent = (MS.strings && MS.strings.readMore) || 'Read more';
      b.addEventListener('click', function () { el.classList.remove('is-clamped'); b.remove(); });
      el.insertAdjacentElement('afterend', b);
    });
    $$('[data-faq-fold]').forEach(function (list) {
      if (list.dataset.folded) return;
      list.dataset.folded = '1';
      list.classList.add('is-fold');
      $$('.q', list).forEach(function (q) {
        var dt = q.querySelector('dt');
        if (!dt) return;
        dt.setAttribute('role', 'button'); dt.tabIndex = 0; dt.setAttribute('aria-expanded', 'false');
        var flip = function () {
          var open = q.classList.toggle('is-open');
          dt.setAttribute('aria-expanded', String(open));
        };
        dt.addEventListener('click', flip);
        dt.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } });
      });
    });
    /* The rating under the title links to #reviews; on a phone that row is
       hidden (Judge.me's block below says the same), so go to Judge.me. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="#reviews"]:not([data-write-review])');
      var row = document.getElementById('reviews');
      if (!a || !row || row.offsetParent !== null) return;
      var w = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-widget');
      if (!w) return;
      e.preventDefault();
      w.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initRecs() {
    $$('.recs[data-recs-url]').forEach(function (el) {
      if (el.dataset.recsDone) return;
      el.dataset.recsDone = '1';
      fetch(el.dataset.recsUrl)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.recs [data-recs-row]');
          var row = el.querySelector('[data-recs-row]');
          /* Swap the tiles, keep the track: the shelf's arrows are bound to it. */
          if (fresh && row && fresh.children.length) {
            row.innerHTML = fresh.innerHTML;
            row.scrollLeft = 0;
            paintSaves();
          }
          if (row && !row.children.length && !(fresh && fresh.children.length)) el.hidden = true;
        })
        .catch(function () {});
    });
  }

  /* ------------------------------------------------------------
     Series: one listing per row. Every member of a series renders
     the same series tile (snippets/series-tile), and a render cannot
     see its neighbours, so a grid with three Trickstarters prints
     three. Keep the first per row or grid and drop the rest. The
     "cell" is the tile's ancestor that sits directly in the list —
     the first parent that has siblings.
     ------------------------------------------------------------ */
  function dedupeSeries(root) {
    var seen = [];
    $$('[data-series]', root).forEach(function (el) {
      if (el.parentElement && el.parentElement.closest('[data-series]')) return;
      var cell = el;
      while (cell.parentElement && cell.parentElement.children.length === 1) cell = cell.parentElement;
      var list = cell.parentElement;
      if (!list) return;
      var key = el.getAttribute('data-series');
      var hit = seen.some(function (s) { return s.list === list && s.key === key; });
      if (hit) cell.remove();
      else seen.push({ list: list, key: key });
    });
  }

  function initSeries() {
    dedupeSeries(document);
    if (window.__seriesObs || !window.MutationObserver) return;
    var queued = false;
    window.__seriesObs = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; dedupeSeries(document); });
    });
    window.__seriesObs.observe(document.body, { childList: true, subtree: true });
  }

  /* Filter sheet, at every width since 2026-10-05: a bottom sheet on a phone,
     a panel from the right on a computer. While open, the page behind is
     scrim-covered and does not scroll; Escape, Done and the scrim close it. */
  function initFilterSheet() {
    var btn = $('[data-fsheet-open]');
    var sheet = $('[data-fsheet]');
    if (!btn || !sheet || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    var scrim = $('.fscrim');

    function setOpen(open) {
      sheet.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        sheet.setAttribute('role', 'dialog');
        sheet.setAttribute('aria-modal', 'true');
      } else {
        sheet.removeAttribute('role');
        sheet.removeAttribute('aria-modal');
      }
      if (scrim) scrim.hidden = !open;
      document.documentElement.classList.toggle('fsheet-open', open);
      if (open) {
        var first = $('.fsheetdone', sheet);
        if (first) first.focus();
      } else {
        btn.focus();
      }
    }

    btn.addEventListener('click', function () { setOpen(true); });
    $$('[data-fsheet-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) setOpen(false);
    });
  }

  /* Show more: fetch only this grid section for the next page and append its
     products. The link is a real next-page URL, so a failed fetch just
     follows it. */
  function initLoadMore() {
    $$('[data-load-next]').forEach(function (link) {
      if (link.dataset.bound) return;
      link.dataset.bound = '1';
      var section = link.closest('[data-section-id]');
      var grid = section && $('.grid', section);
      var count = section && $('[data-load-count]', section);
      if (!grid) return;

      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (link.getAttribute('aria-busy') === 'true') return;
        link.setAttribute('aria-busy', 'true');
        var href = link.getAttribute('href');
        var url = href + (href.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(section.dataset.sectionId);
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextGrid = doc.querySelector('.grid');
            if (!nextGrid) throw new Error('no grid');
            var added = Array.prototype.slice.call(nextGrid.children);
            added.forEach(function (el) { grid.appendChild(el); });
            var nextCount = doc.querySelector('[data-load-count]');
            if (count && nextCount) count.textContent = nextCount.textContent;
            var nextLink = doc.querySelector('[data-load-next]');
            if (nextLink) {
              link.setAttribute('href', nextLink.getAttribute('href'));
              link.removeAttribute('aria-busy');
            } else {
              link.remove();
            }
            /* Keep keyboard and screen-reader users where the new products
               start, not back at the button. */
            var firstLink = added.length && (added[0].matches('a') ? added[0] : added[0].querySelector('a'));
            if (firstLink) firstLink.focus({ preventScroll: true });
          })
          .catch(function () { window.location.href = href; });
      });
    });
  }

  /* Magicians page: the A-Z list is split across sections (a section holds
     50 tiles), and every continued part waits behind one Show more button.
     Without a script every part simply shows. */
  function initMagMore() {
    $$('[data-more-label]').forEach(function (head) {
      if (head.dataset.bound) return;
      head.dataset.bound = '1';
      var wrap = head.closest('.shopify-section');
      var parts = [];
      /* Parts rendered inside the same section (a list from store data). */
      var sib = head.nextElementSibling;
      while (sib) {
        if (sib.classList.contains('maggrid--joined')) parts.push(sib);
        sib = sib.nextElementSibling;
      }
      var next = wrap && wrap.nextElementSibling;
      /* A following section continues this grid only when its own first
         grid is a joined part (not a new list that holds joined parts). */
      function leadsJoined(sec) { var g = sec.querySelector('.maggrid'); return !!(g && g.classList.contains('maggrid--joined')); }
      while (next && leadsJoined(next)) {
        parts.push(next.querySelector('.maggrid--joined'));
        next = next.nextElementSibling;
      }
      if (!parts.length) return;
      function count(el) { return el.querySelectorAll('.ggpick__tile').length; }
      var total = count(head) + parts.reduce(function (n, p) { return n + count(p); }, 0);
      var shown = count(head);
      var box = document.createElement('div');
      box.className = 'magmore';
      var line = document.createElement('p');
      line.className = 'magmore__count';
      line.setAttribute('aria-live', 'polite');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'magmore__btn';
      btn.textContent = head.dataset.moreLabel;
      box.appendChild(line);
      box.appendChild(btn);
      function paint() {
        line.textContent = head.dataset.showing.replace('[s]', shown).replace('[t]', total);
      }
      var last = head;
      function place() {
        var after = last.nextElementSibling;
        if (after === box) after = box.nextElementSibling;
        if (after && after.classList.contains('maggrid--joined')) { last.insertAdjacentElement('afterend', box); }
        else { last.closest('.shopify-section').insertAdjacentElement('afterend', box); }
      }
      paint();
      place();
      btn.addEventListener('click', function () {
        var part = parts.shift();
        if (!part) return;
        part.classList.add('is-shown');
        shown += count(part);
        last = part;
        paint();
        var first = part.querySelector('.ggpick__tile');
        if (first) first.focus({ preventScroll: true });
        if (parts.length) { place(); } else { btn.remove(); place(); }
      });
    });
  }

  /* ------------------------------------------------------------
     "$75 USD" in merchant copy (announcement bar, shipping lines, notes)
     is a US-dollar figure. A shopper browsing in another currency sees it
     in theirs (QA 2026-09-29): Shopify puts the active currency and its
     rate on window.Shopify.currency. Rounded up, so the converted figure
     is never below the real threshold. Text nodes only; nothing else moves.
     ------------------------------------------------------------ */
  function initLocalMoney() {
    var cur = window.Shopify && window.Shopify.currency;
    var rate = cur && parseFloat(cur.rate);
    if (!cur || !cur.active || cur.active === 'USD' || !(rate > 0)) return;
    var re = /\$\s?(\d{1,5}(?:\.\d{2})?)\s?USD\b/g;
    var fmt = function (usd) {
      var n = Math.ceil(parseFloat(usd) * rate);
      var sym = '$';
      try {
        sym = new Intl.NumberFormat('en', { style: 'currency', currency: cur.active, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 })
          .formatToParts(n).filter(function (p) { return p.type === 'currency'; })[0].value;
      } catch (e) {}
      return sym + n + ' ' + cur.active;
    };
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        /* [data-usd] marks figures that really are US dollars for every
           shopper (the gift card's face value, owner 10-03), so they stay. */
        return node.nodeValue.indexOf('USD') > -1 && !(node.parentNode && /^(SCRIPT|STYLE|TEXTAREA)$/.test(node.parentNode.nodeName))
          && !(node.parentNode && node.parentNode.closest && node.parentNode.closest('[data-usd]'))
          ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var hits = [];
    while (walker.nextNode()) hits.push(walker.currentNode);
    hits.forEach(function (node) {
      var next = node.nodeValue.replace(re, function (_, usd) { return fmt(usd); });
      if (next !== node.nodeValue) node.nodeValue = next;
    });
  }

  function boot() {
    initLocalMoney();
    initSeries();
    initAccount();
    initSearch();
    initCart();
    initDrawer();
    initVariants();
    initSaves();
    initWash();
    initGallery();
    initZoom();
    initScrollers();
    initFilters();
    initFilterSheet();
    initLoadMore();
    initMagMore();
    initTheme();
    initCurrency();
    initHeroVideo();
    initHeroSlides();
    initBuyBar();
    initTrailer();
    initChooser();
    initNotify();
    initAnnounce();
    initCountdowns();
    initRecs();
    initFold();
    initCatRow();
    initMega();
    getCart().then(function (cart) { setCartCount(cart.item_count); paintCodeNotes(cart); }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* The theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', boot);
})();

/* Video cards: swap YouTube's thumbnail for the player on tap (privacy-enhanced domain). */
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-yt]');
  if (!b || b.querySelector('iframe')) return;
  const id = encodeURIComponent(b.getAttribute('data-yt'));
  const f = document.createElement('iframe');
  f.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1`;
  f.title = b.getAttribute('aria-label') || 'Video';
  f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
  f.allowFullscreen = true;
  b.appendChild(f);
});


/* Home tile animations (home-float-anim.css): touch screens have no hover,
   so each animated object plays once when it scrolls into view. */
(function () {
  if (!('IntersectionObserver' in window) || !window.matchMedia || !matchMedia('(hover: none)').matches) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-play'); io.unobserve(e.target); } });
  }, { threshold: 0.6 });
  document.querySelectorAll('.fa').forEach(function (el) { io.observe(el); });
})();
